//import { ready } from "../ready-event";
import { setValidatorOptions }  from './form-validation';

console.log("[form-validation-autoinit] loaded ");

$(() => setValidatorOptions());
